import { initialUserState } from './user/userInitialState';
import userAuthReducer from './user/userAuthReducer';
import userOnboardingReducer from './user/userOnboardingReducer';
import userRequisitesReducer from './user/userRequisitesReducer';

export { initialUserState };

export default function user(state = initialUserState, action = {}) {
  let nextState = userAuthReducer(state, action);
  if (nextState !== state) return nextState;

  nextState = userOnboardingReducer(state, action);
  if (nextState !== state) return nextState;

  nextState = userRequisitesReducer(state, action);
  if (nextState !== state) return nextState;

  return state;
}
